import * as _ from 'lodash';
import { FormControlBase } from './form-control-base';
import { FormMinMaxNumberData } from './form-control-data';

export class MinMaxNumberControl extends FormControlBase<number> {
  controlType = 'minmax';
  min: number;
  max: number;
  step: number;
  integerOnly: boolean;

  constructor(options: FormMinMaxNumberData<number> = {}) {
    super(options);
    this.min = options.minimum < options.maximum ? options.minimum : options.maximum;
    this.max = options.minimum < options.maximum ? options.maximum : options.minimum;
    if (!this.min) {
      this.min = 0;
    }
    this.step = options.step ? options.step : 1;
    this.integerOnly = options.integerOnly;
  }

  protected initialize() {
    this.value = this.processValue(_.get(this.model, this.propertyName) as number);
  }

  protected processValue(srcValue) {
    if (srcValue < this.min) {
      return this.min;
    }
    if (srcValue > this.max) {
      return this.max;
    }
    return srcValue;
  }

  onInput(item) {
    if (item.value === '-' || !item.value.length) {
      return;
    }
    item.value = this.processValue(+item.value);
  }

  onKeyPress(event: KeyboardEvent): boolean {
    if (!this.integerOnly) {
      return true;
    }
    const charCode = event.which ? event.which : event.keyCode;
    const nonNumericalCharCode = charCode > 31 && (charCode < 48 || charCode > 57);
    const minusSignCharCode = charCode === 45;
    return !nonNumericalCharCode || minusSignCharCode;
  }

  onPaste(event: ClipboardEvent) {
    if (this.integerOnly) {
      event.preventDefault();
    }
  }
}
